import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconPortfolio = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M19.2675 20H4.7292C4.27085 19.9991 3.83152 19.8227 3.50742 19.5092C3.18332 19.1958 3.00086 18.771 3 18.3277V9.17762C3.00086 8.73437 3.18332 8.30951 3.50742 7.99608C3.83152 7.68265 4.27085 7.50621 4.7292 7.50537H7.36215V5.65642C7.36301 5.21484 7.54479 4.79159 7.86767 4.47935C8.19054 4.1671 8.62821 3.99131 9.08483 3.99048H14.9119C15.3685 3.99131 15.8062 4.1671 16.1291 4.47935C16.452 4.79159 16.6337 5.21484 16.6346 5.65642V7.50537H19.2675C19.7265 7.50537 20.1666 7.68145 20.4914 7.99497C20.8162 8.30849 20.9991 8.73382 21 9.17762V18.3277C20.9991 18.7715 20.8162 19.1968 20.4914 19.5103C20.1666 19.8239 19.7265 20 19.2675 20ZM7 18.0658H18.9967C18.9967 16.9205 18.9967 12.2413 18.9967 9.44897H5.00326C5.00326 10.5975 5.00326 15.2735 5.00326 18.0658H7ZM9.36215 7.51484H14.6346V5.93724H9.36215V7.51484Z" />
      </svg>
    );
  }
);
